import React from 'react';
import FontsDefault from '../../Assistant/DefaultStyle';

import {
  AiOutlineMail,
  AiOutlineHome,
  AiOutlineWhatsApp,
  AiOutlineFullscreen,
  AiOutlineFileProtect,
  AiOutlineCode,
  AiOutlineAntDesign,
  AiOutlineSafety
} from 'react-icons/ai';

function CardIconInfo({
  location,
  description,
  secondDescription,
  AiOutlineMailIcon,
  AiOutlineWhatsAppIcon,
  AiOutlineHomeIcon,
  AiOutlineFullscreenIcon,
  AiOutlineFileProtectIcon,
  AiOutlineCodeIcon,
  AiOutlineAntDesignIcon,
  AiOutlineSafetyIcon
}) {
  return (
    <div className='mt-6 flex'>
      <div>
        {AiOutlineMailIcon && (
          <AiOutlineMail
            className={`${FontsDefault.text6xl} text-amber ml-6`}
          />
        )}

        {AiOutlineWhatsAppIcon && (
          <AiOutlineWhatsApp
            className={`${FontsDefault.text6xl} text-amber ml-6`}
          />
        )}

        {AiOutlineHomeIcon && (
          <AiOutlineHome
            className={`${FontsDefault.text6xl} text-amber ml-6`}
          />
        )}

        {AiOutlineFullscreenIcon && (
          <AiOutlineFullscreen
            className={`${FontsDefault.text6xl} text-amber ml-6`}
          />
        )}

        {AiOutlineFileProtectIcon && (
          <AiOutlineFileProtect
            className={`${FontsDefault.text6xl} text-amber ml-6`}
          />
        )}
        {AiOutlineCodeIcon && (
          <AiOutlineCode
            className={`${FontsDefault.text6xl} text-amber ml-6`}
          />
        )}

        {AiOutlineAntDesignIcon && <AiOutlineAntDesign
          className={`${FontsDefault.text6xl} text-amber ml-6`}
        />}

        {AiOutlineSafetyIcon && <AiOutlineSafety
          className={`${FontsDefault.text6xl} text-amber ml-6`}
        />}
      </div>

      {location ? (
        <div>
          <h1 className={`md:${FontsDefault.text3xl} text-xl text-gray700`}>موقع المكتب</h1>
          <h1 className={`${FontsDefault.text2xl} text-gray500`}>
            فلسطين - غزة
          </h1>
        </div>
      ) : (
        <div>
          <h1 className={`md:text-3xl text-xl text-gray700`}>{description}</h1>
          <h1 className={`md:text-2xl text-sm text-gray500`}>
            {secondDescription}
          </h1>
        </div>
      )}
    </div>
  );
}

export default CardIconInfo;
